export const GET_BUILDINGS = 'GET_BUILDINGS';
export const CRUD_BUILDING = 'CRUD_BUILDING';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const CLEAN_BUILDING_STATE = 'CLEAN_BUILDING_STATE';
export const CLEAN_BUILDING_ERROR = 'CLEAN_BUILDING_ERROR';
export const CHANGE_SETTING_LOCAL = 'CHANGE_SETTING_LOCAL';
export const SET_BUILDING_DATA = 'SET_BUILDING_DATA';
export const SET_FETECHING = 'SET_FETECHING';